<div class='min-w-[480px] min-h-[600px]'>
  <div class='flex flex-col gap-[8px] h-auto py-4 px-6 mx-auto bg-white rounded-[12px] shadow-lg'>
    <div class='flex flex-row'>
      <a class='basis-1/3 flex flex-row cursor-pointer text-dark hover:text-dark' [routerLink]='login'>
        <svg-icon src='/assets/icons/logo.svg'></svg-icon>
        <h1 class='text-[20px] ml-3'><strong class='mr-1'>Neon</strong><span>Task</span></h1>
      </a>
      <div class='flex flex-row items-center basis-1/3 justify-end'>
      </div>
    </div>
    <router-outlet></router-outlet>
  </div>
</div>
